export interface CountryCurrency {
    country: string;
    countryCode: string; // ISO 3166-1 alpha-2
    currency: string;
    currencyCode: string; // ISO 4217
    locale: string;
    symbol: string;
}

export interface CultureShort {
    currencyCode: string; // ISO 4217
    locale: string;
}

export const DEFAULT_CULTURE = {
    US_STOCKS: {
        country: "United States",
        countryCode: "US",
        currency: "US Dollar",
        currencyCode: "USD",
        locale: "en-US",
        symbol: "$",
    },
};

export const DEFAULT_CULTURE_SHORT = {
    US_STOCKS: {
        currencyCode: "USD",
        locale: "en-US",
    },
};

export const COUNTRY_CURRENCY_LIST: CountryCurrency[] = [
    {
        country: "United States",
        countryCode: "US",
        currency: "US Dollar",
        currencyCode: "USD",
        locale: "en-US",
        symbol: "$",
    },
    {
        country: "United Kingdom",
        countryCode: "GB",
        currency: "British Pound",
        currencyCode: "GBP",
        locale: "en-GB",
        symbol: "£",
    },
    {
        country: "European Union",
        countryCode: "EU",
        currency: "Euro",
        currencyCode: "EUR",
        locale: "de-DE",
        symbol: "€",
    },
    {
        country: "Canada",
        countryCode: "CA",
        currency: "Canadian Dollar",
        currencyCode: "CAD",
        locale: "en-CA",
        symbol: "$",
    },
    {
        country: "Australia",
        countryCode: "AU",
        currency: "Australian Dollar",
        currencyCode: "AUD",
        locale: "en-AU",
        symbol: "$",
    },
    {
        country: "India",
        countryCode: "IN",
        currency: "Indian Rupee",
        currencyCode: "INR",
        locale: "en-IN",
        symbol: "₹",
    },
    {
        country: "Japan",
        countryCode: "JP",
        currency: "Japanese Yen",
        currencyCode: "JPY",
        locale: "ja-JP",
        symbol: "¥",
    },
    {
        country: "China",
        countryCode: "CN",
        currency: "Yuan Renminbi",
        currencyCode: "CNY",
        locale: "zh-CN",
        symbol: "¥",
    },
    {
        country: "Brazil",
        countryCode: "BR",
        currency: "Brazilian Real",
        currencyCode: "BRL",
        locale: "pt-BR",
        symbol: "R$",
    },
    {
        country: "South Africa",
        countryCode: "ZA",
        currency: "South African Rand",
        currencyCode: "ZAR",
        locale: "en-ZA",
        symbol: "R",
    },
];
